/**
 * Syndicate: colour-filtered product gallery.
 * Media alt text is tagged with the colour name (e.g. "... - Burnt Red - side view").
 * When the Colour option changes, only media tagged with that colour (plus untagged, shared media) stays visible.
 * Activates only on products where at least two colours are represented in the media alts; otherwise it is a no-op.
 */
(function () {
  function init() {
    document.querySelectorAll('media-gallery[data-syn-colours]').forEach(function (gallery) {
      var colours;
      try { colours = JSON.parse(gallery.dataset.synColours); } catch (e) { return; }
      var idx = parseInt(gallery.dataset.synColourIndex, 10);
      if (!colours || colours.length < 2 || isNaN(idx)) return;
      var sectionId = gallery.id.replace('MediaGallery-', '');
      var selector = document.querySelector('variant-radios[data-section="' + sectionId + '"], variant-selects[data-section="' + sectionId + '"]');
      var lcColours = colours.map(function (c) { return String(c).toLowerCase(); });

      function colourOf(el) {
        var img = el.querySelector('img');
        var alt = ((img && img.getAttribute('alt')) || '').toLowerCase();
        var best = null;
        lcColours.forEach(function (c) { if (alt.indexOf(c) !== -1 && (!best || c.length > best.length)) best = c; });
        return best;
      }

      function items() {
        var list = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item, .thumbnail-list__item'));
        var modal = document.querySelector('#ProductModal-' + sectionId);
        if (modal) list = list.concat(Array.prototype.slice.call(modal.querySelectorAll('[data-media-id]')));
        return list;
      }

      var all = items();
      var represented = {};
      all.forEach(function (el) { var c = colourOf(el); if (c) represented[c] = 1; });
      if (Object.keys(represented).length < 2) return;

      function apply(colour) {
        if (!colour) return;
        var lc = String(colour).toLowerCase();
        items().forEach(function (el) {
          var c = colourOf(el);
          el.classList.toggle('syn-colour-hidden', !!c && c !== lc);
        });
        gallery.querySelectorAll('slider-component').forEach(function (s) {
          if (typeof s.initPages === 'function') s.initPages();
          if (typeof s.resetPages === 'function') s.resetPages();
        });
        // Dawn prepends the new colour's photo, but scroll anchoring keeps the mobile slider parked on the old
        // slide (which we just hid), so the shopper sees the next untagged photo instead. Jump to the active one.
        var active = gallery.querySelector('.product__media-item.is-active');
        if (active && !active.classList.contains('syn-colour-hidden')) {
          var list = active.parentElement;
          if (list && list.scrollWidth > list.clientWidth + 1) list.scrollTo({ left: active.offsetLeft, behavior: 'instant' });
        }
      }

      function current() {
        if (!selector) return null;
        try { selector.updateOptions(); selector.updateMasterId(); } catch (e) {}
        var v = selector.currentVariant;
        return v && v.options ? v.options[idx] : null;
      }

      apply(current());
      if (selector) selector.addEventListener('change', function () { setTimeout(function () { apply(current()); }, 0); });

      // Dawn's gallery arrows/keyboard step through EVERY media item, including the ones we hid for the other
      // colours. Landing on a hidden slide collapses the viewer to a few px. Watch for that and redirect to the
      // nearest visible slide in the same direction (wrapping around at either end).
      var viewer = gallery.querySelector('[id^="GalleryViewer"]');
      function installRedirect() {
        if (!viewer || typeof gallery.setActiveMedia !== 'function' || !window.MutationObserver) return;
        var lastActive = viewer.querySelector('.product__media-item.is-active');
        var redirecting = false;
        var mo = new MutationObserver(function (muts) {
          if (redirecting) return;
          var landed = null;
          muts.forEach(function (m) {
            var el = m.target;
            if (el.classList && el.classList.contains('product__media-item') && el.classList.contains('is-active')) landed = el;
          });
          if (!landed) return;
          if (!landed.classList.contains('syn-colour-hidden')) { lastActive = landed; return; }
          var all = Array.prototype.slice.call(viewer.querySelectorAll('.product__media-item'));
          var visible = all.filter(function (el) { return !el.classList.contains('syn-colour-hidden'); });
          if (!visible.length) return;
          var from = all.indexOf(lastActive), to = all.indexOf(landed), target;
          var after = visible.filter(function (el) { return all.indexOf(el) > to; });
          var before = visible.filter(function (el) { return all.indexOf(el) < to; });
          var firstVis = all.indexOf(visible[0]), lastVis = all.indexOf(visible[visible.length - 1]);
          var forward = (from === -1) || (to > from);
          if (forward && from === firstVis && !after.length) forward = false;   // "previous" from the first photo wrapped past the end
          if (!forward && from === lastVis && !before.length) forward = true;   // "next" from the last photo wrapped before the start
          target = forward ? (after[0] || visible[0]) : (before[before.length - 1] || visible[visible.length - 1]);
          redirecting = true;
          try { gallery.setActiveMedia(target.dataset.mediaId, false); } finally { redirecting = false; }
          lastActive = target;
        });
        mo.observe(viewer, { attributes: true, attributeFilter: ['class'], subtree: true });
      }
      // this script is deferred ahead of media-gallery.js, so the component may not be upgraded yet
      if (window.customElements && customElements.whenDefined) customElements.whenDefined('media-gallery').then(installRedirect);
      else installRedirect();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
